import { render, staticRenderFns } from "./CustomerCommunicationView.vue?vue&type=template&id=9986c2b2&lang=pug&"
import script from "./CustomerCommunicationView.vue?vue&type=script&lang=js&"
export * from "./CustomerCommunicationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports